export default __webpack_public_path__ + "static/media/plus-circle.b8db6be6.svg";